#import "../fragments/potential-activity-entity-fragment.graphql"

query GetActivityDefaults($input: ActivityDefaultsInput) {
    activityDefaults(input: $input) {
        name
        quillDelta
        logNote
        activityType {
            id
            name
        }
        startTime
        endTime
        relatedEntities {
            ...PotentialActivityEntityFragment
        }
        participants {
            ...PotentialActivityEntityFragment
        }
        creatorUser {
            id
            name
        }
        previousActivity {
            id
            name
        }
    }
}
